import { render, staticRenderFns } from "./ModalProductList.vue?vue&type=template&id=d4fb6000&scoped=true&"
import script from "./ModalProductList.vue?vue&type=script&lang=js&"
export * from "./ModalProductList.vue?vue&type=script&lang=js&"
import style0 from "./ModalProductList.vue?vue&type=style&index=0&id=d4fb6000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fb6000",
  null
  
)

export default component.exports